<template>
  <div class="background-image">
    <Tubiao></Tubiao>
    <div class="imgcon">
      <div class="imgcc"></div>
      <div class="imgtit"><span>提交成功！</span></div>
    </div>
  </div>
</template>

<script>
import Tubiao from "./tubiao.vue";
export default {
  components: {
    Tubiao
  },
  props: {

  },
  data() {
    return {


    };
  },
  computed: {

  },

  methods: {

  },


}

</script>

<style scoped lang="less">
.background-image {
  width: 100%;
  /* 宽度设置为100% */
  height: 100%;
  /* 高度设置为视口高度 */
  background-image: url('../../assets/img/111.png');
  /* 背景图片路径 */
  background-size: cover;
  /* 背景图片覆盖整个元素 */
  background-position: center;
  /* 背景图片居中 */
  background-repeat: no-repeat;
  /* 背景图片不重复 */
  display: flex;
  justify-content: center;
  flex-direction: column;

  .imgcon {
    width: 80vw;
    height: 85vw;
    background: white;
    margin: 0 auto;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .3);
    border-radius: 6px;

    .imgcc {
      width: 75%;
      height: 60%;
      margin: 0 auto;
      margin-top: 4vh;
      background-image: url('../../assets/img/tj.jpg');
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
    }

    .imgtit {
      width: 75%;
      height: 30%;
      margin: 0 auto;
      margin-top: 4vh;

      span {
        font-family: 'PingFang Heavy';
        font-size: 6vw;
      }
    }
  }
}
</style>